import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const CURRICULUM_CLUSTER: BuildingBlockNodeConfig = {
  nodeSelector: selectTitleNode,
  information: {
    single: 'Leerplancluster',
    plural: 'Leerplanclusters',
  },

  buildingBlocks: [{ type: NodeType.CURRICULUM_THEME }],
  edit: [titleComponent],
  onNewNodeDropped: {
    focusOnField: 'title',
  },
  confirmDelete: true,
  themesDisplaySuffix: '(cluster)',
  isCollapsible: false,
};

export default CURRICULUM_CLUSTER;
